export const draftEmployeeHeaderColumns = [
	{
		field: "employeeId",
		headerName: "Employee Id",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 0,
		frozenColumn: true,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "firstName",
		headerName: "First Name",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 1,
		frozenColumn: true,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "lastName",
		headerName: "Last Name",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 2,
		frozenColumn: true,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "initials",
		headerName: "Initials",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 3,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "dateOfBirth",
		headerName: "Date Of Birth",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 4,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "gender",
		headerName: "Gender",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 5,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "socialInsuranceNumber",
		headerName: "Social Insurance Number",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 6,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "sinStatus",
		headerName: "Sin Status",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 7,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "followUpNotes",
		headerName: "Follow Up Notes",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 8,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "address",
		headerName: "Address",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 9,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "city",
		headerName: "City",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 10,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "province",
		headerName: "Province",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 11,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "postCode",
		headerName: "Post Code",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 12,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "payFrequency",
		headerName: "Payroll Schedule",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 13,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "dateOfHire",
		headerName: "Date Of Hire",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 14,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "phone",
		headerName: "Phone",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 15,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "provinceOfEmployment",
		headerName: "Province Of Employment",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 30,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "payMethod",
		headerName: "Pay Method",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 16,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "howIsEmployPaid",
		headerName: "How Is Employee Paid",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 16,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "regularSalaryForThePeriod",
		headerName: "Regular Salary/Rate",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 16,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "vacationPay",
		headerName: "Vacation Pay",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 17,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "payOutVacationPay",
		headerName: "Pay Out Vacation Pay",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 18,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "vacationPayOpenBalance",
		headerName: "Vacation Pay Open Balance",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 19,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "includeInT4OrRl1",
		headerName: "Include In T4 Or Rl1",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 20,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "dentalBenefits",
		headerName: "Dental Benefits",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 21,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "stubLanguage",
		headerName: "Stub Language",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 22,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "emailStub",
		headerName: "Email Stub",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 23,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "printHourlyRateOnStub",
		headerName: "Print Hourly Rate On Stub",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 24,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "stubNotes",
		headerName: "Stub Notes",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 25,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "datePensionBecomePayable",
		headerName: "Date Pension Becomes Payable",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 26,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "rppOrDpspRegistrationNo",
		headerName: "Rpp Or Dpsp Registration No",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 27,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "dateOfDisability",
		headerName: "Date Of Disability",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 28,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
	{
		field: "dateDisabilityWasCeased",
		headerName: "Date Disability Was Ceased",
		description: "",
		flex: 1,
		hide: false,
		hideable: false,
		sortable: false,
		sortingOrder: "asc",
		resizable: false,
		type: "string",
		align: "left",
		headerAlign: "left",
		hideSortIcons: false,
		disableColumnMenu: true,
		disableReorder: true,
		disableExport: true,
		maskable: false,
		isFixed: true,
		sequence: 29,
		frozenColumn: false,
		footer: null,
		minWidth: null,
		maxWidth: null,
		fieldName: null,
	},
];
